import { gql } from "@apollo/client";

const CREATE_EVENT_REGISTRATION_INVITE = gql`
  mutation createEventRegistrationInvite(
    $data: CreateEventRegistrationInviteInput!
  ) {
    createEventRegistrationInvite(data: $data) {
      id
      event {
        id
        name
      }
      organization {
        id
        name
      }
      email
      name
      handle
    }
  }
`;

export default CREATE_EVENT_REGISTRATION_INVITE;
